import { Stack } from '@mui/material'
import React, { ReactNode } from 'react'

import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import Icon from 'components/Icon'
import { GraphNodeGlyphIcon } from 'components/scenarios/concurrent/GraphNodeGlyphIcon'
import { GraphNodeNameDuration } from 'components/scenarios/concurrent/GraphNodeNameDuration'
import { GraphNodeWrapper } from 'components/scenarios/concurrent/GraphNodeWrapper'

import type { FailureFlagNode, GraphNode } from 'types/api/scenarios/scenario'

export const FailureFlagGraphNode: React.FC<{
  node: FailureFlagNode
  isClickable?: boolean
  rowActions?: ReactNode
  onClick?: (node: GraphNode) => void
}> = ({ node, isClickable = false, rowActions, onClick }) => {
  const applicationName = node.failureFlagInputForScenario.app.name
  const flagName = node.failureFlagInputForScenario.flag.name

  return (
    <GraphNodeWrapper
      details={
        <>
          <GraphNodeGlyphIcon node={node} />
          <GraphNodeNameDuration node={node} />
        </>
      }
      impact={
        <Stack spacing={0.2}>
          <TruncatedTextWithTooltip
            color="grey.700"
            tooltipProps={{ title: applicationName }}
            variant="caption"
          >
            {applicationName}
          </TruncatedTextWithTooltip>
          {flagName && (
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="nowrap"
              spacing={0.5}
            >
              <Icon icon="flag" />
              <TruncatedTextWithTooltip
                color="grey.700"
                tooltipProps={{ title: flagName }}
                variant="caption"
              >
                {flagName}
              </TruncatedTextWithTooltip>
            </Stack>
          )}
        </Stack>
      }
      isClickable={isClickable}
      node={node}
      rowActions={rowActions}
      onClick={onClick}
    />
  )
}
